import React from "react";
import { Checkbox } from "antd";

export default function SelectBoxes({
  label,
  required = false,
  error = false,
  onChange,
  value,
  options = [],
}) {
  return (
    <>
      {label && (
        <label
          className={`editLabelForm text-bold my-1 ${
            error ? "text-danger" : ""
          }`}
        >
          {label} {required && <span className="orange_color">*</span>}
        </label>
      )}
      <div className="d-flex flex-wrap">
        {options.map((d) => {
          const checked = value.includes(d.value);
          const onClick = () => {
            let departments = value;
            if (departments.includes(d.value))
              departments = departments.filter((val) => val !== d.value);
            else departments.push(d.value);

            onChange(departments);
          };
          return (
            <div
              key={d.value}
              className="mr-2 mb-2 cursor-pointer px-2 py-1"
              style={{
                background: checked ? "#E4F0FB" : "#fff",
                border: `1px solid ${checked ? "#007BFF" : "#D9D9D9"}`,
                borderRadius: 4,
                fontSize: 15,
                // lineHeight: 18,
                textAlign: "center",
                color: checked ? "#000000" : "#6C6C6C",
              }}
              onClick={onClick}
            >
              <div className="d-flex align-items-center">
                <Checkbox checked={checked} className="mr-2" />
                {d.label}
              </div>
            </div>
          );
        })}
      </div>
      {error && <div className="text-danger">{error}</div>}
    </>
  );
}
